class RangeInputController {
  constructor() {
		this.interestLabel = "Medium";
  }

  updateLabel(interest) {
    if (interest == 0) {
      this.interestLabel = "None";
    } else if (interest > 0 && interest < 3) {
      this.interestLabel = "Low";
    } else if (interest >= 3 && interest < 8) {
      this.interestLabel = "Medium";
    } else if (interest >= 8) {
      this.interestLabel = "High";
    }
  }
}

export default RangeInputController;



// WEBPACK FOOTER //
// ./src/components/rangeInput/rangeInput.controller.js